import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { store } from './store';
import { theme } from './styles/theme';
import { GlobalStyle } from './styles/GlobalStyle';
import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { NotificationContainer } from './components/common/NotificationContainer';
import { Login } from './pages/Login';
import { Clients } from './pages/Clients';
import { CertificatesMonitoring } from './pages/CertificatesMonitoring';
import { ManagementClients } from './pages/ManagementClients';
import { Organizations } from './pages/Organizations';
import { Settings } from './pages/Settings';
import { Logs } from './pages/Logs';
import { Help } from './pages/Help';

function DefaultRedirect() {
  return <Navigate to="/clients" replace />;
}

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <ErrorBoundary>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DefaultRedirect />} />
                <Route path="clients" element={<Clients />} />
                <Route path="certificates" element={<CertificatesMonitoring />} />
                <Route path="management-clients" element={<ManagementClients />} />
                <Route path="organizations" element={<Organizations />} />
                <Route path="logs" element={<Logs />} />
                <Route path="help" element={<Help />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Routes>
            <NotificationContainer />
          </Router>
        </ErrorBoundary>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
